<template>
  <div>
    <el-dialog
      :id="$options.name"
      :before-close="noDialog"
      :fullscreen="dialogFullscreen"
      :visible.sync="dialog"
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="2vh"
    >
      <el-form ref="Dto" :model="groupForm" :rules="rules" label-width="auto">
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="小区名称" prop="groupName">
              <el-input
                v-model="groupForm.groupName"
                placeholder="请输小区名称"
                maxlength="40"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="手机号码" prop="mobile">
              <el-input
                v-model="groupForm.mobile"
                maxlength="11"
                placeholder="请输入联系人手机号"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="位置信息" prop="address">
              <el-row>
                <template v-if="location !== undefined">
                  <el-col :span="17" :xs="12">
                    <el-input v-model="locationText" readonly />
                  </el-col>
                </template>
                <el-col :span="7" :xs="12">
                  <el-button plain type="primary" @click="mapDialog = true"
                    >点击定位</el-button
                  >
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="具体位置">
              <el-input
                disabled
                v-model="groupForm.address"
                placeholder="请通过定位获取位置"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row>
          <el-col :span="12" :xs="24">
            <el-form-item label="最大功率" prop="maxPower">
              <el-input
                v-model.number="groupForm.maxPower"
                placeholder="请输入最大功率"
              >
                <template slot="append">W</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="限时充电" prop="chargeMaxTime">
              <el-input
                v-model.number="groupForm.chargeMaxTime"
                placeholder="请输最长充电时间"
              >
                <template slot="append">小时</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- <el-row>
          <el-col :span="12" :xs="24">
            <el-form-item label="电费成本" prop="costOfPowerFare">
              <el-input
                v-model="groupForm.costOfPowerFare"
                placeholder="请输电费成本"
              >
                <template slot="append">元/度</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
           
          </el-col>
        </el-row> -->
        <el-collapse v-model="activeCollapse" accordion>
          <el-collapse-item name="1">
            <template slot="title">
              <div class="collapse_label">
                <Icon
                  :style="{ color: '#f67e7e' }"
                  class="required_icon"
                  icon="icon-bitian-red-left-down"
                />
                <Icon
                  :style="{ color: '#f4b646' }"
                  class="label_icon"
                  icon="icon-shoufei"
                />
                收费方式：
              </div>
            </template>
            <el-form
              ref="params"
              :label-position="labelPosition"
              :model="params"
              :rules="rules"
              label-width="auto"
            >
              <el-row class="collapse_content" :gutter="10">
                <el-col :span="12" :xs="24">
                  <el-row class="collapse_content_wrapper">
                    <el-col :span="4" :xs="5">收起步价</el-col>
                    <el-col :span="20" :xs="19">
                      <el-switch
                        v-model="isStartingPrice"
                        :active-value="1"
                        :inactive-value="0"
                        @change="handleIsStartingPriceSwitchChange"
                      >
                      </el-switch>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="12" :xs="24" v-if="isStartingPrice == 1">
                  <el-row class="collapse_content_wrapper">
                    <el-col :span="4" :xs="5">起步价格</el-col>
                    <el-col :span="20" :xs="19">
                      <el-input
                        v-model="params.startingFare"
                        maxlength="4"
                        placeholder="请输入起步价格"
                      >
                        <template slot="append">元</template>
                      </el-input>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-row class="collapse_content">
                <el-col :span="2" :xs="5">计费方式</el-col>
                <el-col :span="22" :xs="19"
                  ><el-radio-group
                    v-model="params.chargeType"
                    @change="changeChargeType"
                  >
                    <el-radio-button label="1">按时间</el-radio-button>
                    <el-radio-button label="3">按功率</el-radio-button>
                    <el-radio-button label="2">按度数</el-radio-button>
                  </el-radio-group>
                </el-col>
              </el-row>
              <template v-if="params.chargeType === '2'">
                <el-row class="collapse_content" :gutter="10">
                  <el-col :span="12" :xs="24">
                    <el-row class="collapse_content_wrapper">
                      <el-col :span="4" :xs="5">收费类型</el-col>
                      <el-col :span="20" :xs="19">
                        <el-radio
                          style="margin-right: 8px"
                          v-model="params.serviceChargeByTime"
                          :label="0"
                          >按度数收服务费</el-radio
                        >
                        <el-radio
                          v-model="params.serviceChargeByTime"
                          :label="1"
                          >按时间收服务费</el-radio
                        >
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>

                <el-row class="collapse_content" :gutter="10">
                  <template v-if="params.serviceChargeByTime == 1">
                    <el-col :span="8" :xs="24">
                      <el-row class="collapse_content_wrapper">
                        <el-col :span="5" :xs="5">服务时长</el-col>
                        <el-col :span="19" :xs="19">
                          <el-form-item>
                            <el-input-number
                              v-model="params.serviceChargeTime"
                              :min="1"
                              step-strictly
                            ></el-input-number
                            >&nbsp;&nbsp;分钟
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8" :xs="24">
                      <el-row class="collapse_content_wrapper">
                        <el-col :span="5" :xs="5">服务费用</el-col>
                        <el-col :span="19" :xs="19">
                          <el-form-item>
                            <el-input
                              type="number"
                              v-model="params.serviceChargeTimeMoney"
                              maxlength="4"
                              placeholder="请输入服务费"
                            >
                              <template slot="append">元</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </template>
                </el-row>
                <template v-if="chargeRuleByDegType == '0'">
                  <el-row class="collapse_content" :gutter="10">
                    <el-col :span="12" :xs="24">
                      <el-row class="collapse_content_wrapper">
                        <el-col :span="4" :xs="5">电费价格</el-col>
                        <el-col :span="20" :xs="19">
                          <el-input
                            v-model="params.powerFare"
                            maxlength="4"
                            placeholder="请输入电费价格"
                            type="number"
                            @input="handleFareInput('powerFare')"
                          >
                            <template slot="append">元/度</template>
                          </el-input>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="12" :xs="24">
                      <el-row class="collapse_content_wrapper">
                        <el-col :span="4" :xs="5">服务费用</el-col>
                        <el-col :span="20" :xs="19">
                          <el-input
                            v-model="params.powerServiceFare"
                            maxlength="4"
                            placeholder="请输入服务费用"
                            type="number"
                            @input="handleFareInput('powerServiceFare')"
                          >
                            <template slot="append">元/度</template>
                          </el-input>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </template>
                <template v-else>
                  <el-divider>收费时段设置</el-divider>
                  <div style="display: flex; align-items: center">
                    <el-tooltip
                      effect="dark"
                      content="开启后，可分不同时段收费"
                      placement="top-start"
                    >
                      <div>
                        <label
                          class="el-form-item__label"
                          style="width: auto; padding: 0 12px 0 0"
                          >峰谷收费
                          <i
                            class="el-icon-question"
                            style="font-size: 17px; vertical-align: text-bottom"
                          ></i
                        ></label>
                      </div>
                    </el-tooltip>
                    <el-switch
                      v-model="isPeekCharge"
                      :active-value="1"
                      :inactive-value="0"
                      @change="handleIsPeekChargeSwitchChange"
                    >
                    </el-switch>
                  </div>
                  <template
                    v-for="(
                      item, index
                    ) in params.informationOfChargeByPowerList"
                  >
                    <el-row
                      class="collapse_content"
                      :gutter="10"
                      :key="item.startTime"
                    >
                      <div class="content_charge_rule">
                        <template v-if="isPeekCharge == 1">
                          <el-col :span="8" :xs="24">
                            <el-row class="collapse_content_wrapper">
                              <el-col :span="6" :xs="5">峰谷标识</el-col>
                              <el-col :span="18" :xs="19">
                                <el-radio v-model="item.peak" label="0"
                                  >谷</el-radio
                                >
                                <el-radio v-model="item.peak" label="1"
                                  >平</el-radio
                                >
                                <el-radio v-model="item.peak" label="2"
                                  >峰</el-radio
                                >
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="8" :xs="24">
                            <el-row class="collapse_content_wrapper">
                              <el-col :span="6" :xs="5">开始时间</el-col>
                              <el-col :span="18" :xs="19">
                                <el-input-number
                                  v-model="item.startTime"
                                  :min="startTimeMinValue(index)"
                                  :max="
                                    index == 0 ? 0 : startTimeMaxValue(item)
                                  "
                                  @change="
                                    handleStartTimeNumberBoxChange(
                                      $event,
                                      index
                                    )
                                  "
                                ></el-input-number>
                                <span style="margin-left: 14px">时</span>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="8" :xs="24">
                            <el-row class="collapse_content_wrapper">
                              <el-col :span="6" :xs="5">结束时间</el-col>
                              <el-col :span="18" :xs="19">
                                <el-input-number
                                  v-model="item.endTime"
                                  :min="endTimeMinValue(item)"
                                  :max="endTimeMaxValue(index)"
                                  @change="
                                    handleEndTimeNumberBoxChange($event, index)
                                  "
                                ></el-input-number>
                                <span style="margin-left: 14px">时</span>
                              </el-col>
                            </el-row>
                          </el-col>
                        </template>

                        <el-col
                          :span="params.serviceChargeByTime == 0 ? 12 : 24"
                          :xs="24"
                        >
                          <el-row class="collapse_content_wrapper">
                            <el-col :span="4" :xs="5">电费价格</el-col>
                            <el-col :span="20" :xs="19">
                              <el-input
                                v-model="item.powerFare"
                                maxlength="4"
                                placeholder="请输入电费价格"
                                type="number"
                                @input="handleFareInput(index, 'powerFare')"
                              >
                                <template slot="append">元/度</template>
                              </el-input>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col
                          :span="12"
                          :xs="24"
                          v-if="params.serviceChargeByTime == 0"
                        >
                          <el-row class="collapse_content_wrapper">
                            <el-col :span="4" :xs="5">服务费用</el-col>
                            <el-col :span="20" :xs="19">
                              <el-input
                                v-model="item.powerServiceFare"
                                maxlength="4"
                                placeholder="请输入服务费用"
                                type="number"
                                @input="
                                  handleFareInput(index, 'powerServiceFare')
                                "
                              >
                                <template slot="append">元/度</template>
                              </el-input>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="12" :xs="24" v-if="isPeekCharge == 1">
                          <div style="display: flex; margin-top: 10px">
                            <div
                              v-if="
                                item.endTime < 24 &&
                                index ==
                                  params.informationOfChargeByPowerList.length -
                                    1
                              "
                              style="width: 100px; margin-right: 10px"
                            >
                              <el-button
                                type="primary"
                                @click="handleAddChargeRule"
                                >新增</el-button
                              >
                            </div>
                            <div
                              v-if="
                                index > 0 &&
                                index ==
                                  params.informationOfChargeByPowerList.length -
                                    1
                              "
                              style="width: 100px"
                            >
                              <el-button
                                type="danger"
                                @click="handleRemoveChargeRule"
                                >删除</el-button
                              >
                            </div>
                          </div>
                        </el-col>
                      </div>
                    </el-row>
                  </template>
                </template>
              </template>

              <template v-else>
                <el-row class="collapse_content" :gutter="10">
                  <el-col :span="24">
                    <el-row
                      class="collapse_content_wrapper"
                      v-for="(item, index) in params.chargeTemplateInfoList"
                      :key="index"
                    >
                      <el-col class="wrapper_detail" :span="2" :xs="24"
                        >价格详细</el-col
                      >
                      <el-col :span="22" :xs="24">
                        <el-row>
                          <el-col :span="4" :xs="11">
                            <el-form-item
                              :prop="
                                'chargeTemplateInfoList.' + index + '.money'
                              "
                              :rules="rules.money"
                            >
                              <el-input v-model="item.money" maxlength="4">
                                <template slot="append">元</template>
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="1" class="t-c hidden-sm-and-up">
                            <div class="col_line">-</div>
                          </el-col>
                          <el-col :span="5" :xs="12">
                            <el-form-item
                              :prop="
                                'chargeTemplateInfoList.' + index + '.interval'
                              "
                              :rules="rules.interval"
                            >
                              <el-input v-model.number="item.interval">
                                <template slot="append">分钟</template>
                              </el-input>
                            </el-form-item>
                          </el-col>

                          <el-col :span="4" :xs="11" class="xs-m-p">
                            <el-form-item
                              :prop="
                                'chargeTemplateInfoList.' +
                                index +
                                '.startPower'
                              "
                              :rules="rules.startPower"
                            >
                              <el-input
                                v-model.number="item.startPower"
                                disabled
                              >
                                <template slot="append">瓦</template>
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="1" class="t-c xs-m-p">
                            <div class="col_line">-</div>
                          </el-col>
                          <el-col :span="4" :xs="12" class="xs-m-p">
                            <el-form-item
                              :prop="
                                'chargeTemplateInfoList.' + index + '.endPower'
                              "
                              :rules="rules.endPower"
                            >
                              <el-input v-model.number="item.endPower">
                                <template slot="append">瓦</template>
                              </el-input>
                            </el-form-item>
                          </el-col>

                          <template v-if="params.chargeType === '3'">
                            <el-col :span="3" :xs="6" class="xs-m-p">
                              <el-button
                                v-if="listStart(index)"
                                type="primary"
                                @click="addItem(item)"
                              >
                                新增
                              </el-button>
                            </el-col>
                            <el-col :span="3" :xs="6" class="xs-m-p">
                              <el-button
                                v-if="listEnd(index)"
                                type="danger"
                                @click="
                                  removeItem(
                                    item,
                                    params.chargeTemplateInfoList
                                  )
                                "
                              >
                                删除
                              </el-button>

                              <el-button
                                v-if="listOnlyOne(index)"
                                @click="resetItem()"
                              >
                                重置
                              </el-button>
                            </el-col>
                          </template>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </template>
            </el-form>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <div class="collapse_label">
                <Icon
                  :style="{ color: '#82b8ff' }"
                  class="label_icon"
                  icon="icon-yuebao"
                />包月方式：
              </div>
            </template>
            <div style="color: #818181">
              <span style="font-weight: bold">注意：</span
              >修改最大功率会导致对应包月套餐下的用户无法续费，用户需要重新开通包月，但不会影响其正常使用
            </div>
            <el-form
              ref="params2"
              :model="params2"
              :rules="rules2"
              label-width="auto"
            >
              <el-row class="collapse_content" :gutter="10">
                <el-col :span="24">
                  <el-row
                    class="collapse_content_wrapper"
                    v-for="(item, index) in params2.monthlyInfoList"
                    :key="index"
                  >
                    <el-col class="wrapper_detail" :span="2" :xs="24"
                      >价格详细</el-col
                    >
                    <el-col :span="22" :xs="24">
                      <el-row>
                        <el-col :span="4" :xs="11">
                          <el-form-item
                            :prop="'monthlyInfoList.' + index + '.money'"
                            :rules="rules2.money"
                          >
                            <el-input v-model="item.money" maxlength="4">
                              <template slot="append">元</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="1" class="t-c hidden-sm-and-up">
                          <div class="col_line">-</div>
                        </el-col>
                        <el-col :span="4" :xs="12">
                          <el-form-item
                            :prop="
                              'monthlyInfoList.' + index + '.freeChargeNum'
                            "
                            :rules="rules2.freeChargeNum"
                          >
                            <el-input
                              v-model.number="item.freeChargeNum"
                              maxlength="3"
                            >
                              <template slot="append">小时</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <!-- <el-col :span="3" :xs="10" class="xs-m-p">
                          <el-form-item
                            :prop="'monthlyInfoList.' + index + '.startPower'"
                            :rules="rules.startPower"
                          >
                            <el-input
                              v-model.number="item.startPower"
                              disabled
                            />
                          </el-form-item>
                        </el-col> -->
                        <el-col :span="1" class="t-c xs-m-p hidden-sm-and-down">
                          <div class="col_line">-</div>
                        </el-col>
                        <el-col :span="7" :xs="24" class="xs-m-p">
                          <el-form-item
                            :prop="'monthlyInfoList.' + index + '.endPower'"
                            :rules="rules2.endPower"
                          >
                            <el-input
                              v-model.number="item.endPower"
                              maxlength="4"
                            >
                              <template slot="prepend">最大功率</template>
                              <template slot="append">瓦</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="2" :xs="6" class="xs-m-p">
                          <el-button
                            v-if="listStart(index, 'params2')"
                            type="primary"
                            @click="addItem(item, 'params2')"
                          >
                            新增
                          </el-button>
                        </el-col>
                        <el-col :span="2" :xs="6" class="xs-m-p">
                          <el-button
                            v-if="listEnd(index, 'params2')"
                            type="danger"
                            @click="removeItem(item, params2.monthlyInfoList)"
                          >
                            删除
                          </el-button>

                          <el-button
                            v-if="listOnlyOne(index, 'params2')"
                            @click="resetItem('params2')"
                          >
                            重置
                          </el-button>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title">
              <div class="collapse_label">
                <Icon
                  :style="{ color: '#29c19b' }"
                  class="label_icon"
                  icon="icon-jifen"
                />百分比分成：
              </div>
            </template>
            <el-row
              v-for="(item, index) in groupForm.groupDividendConfList"
              :key="index"
              :gutter="10"
            >
              <el-col :span="9" :xs="24">
                <el-row class="collapse_content">
                  <el-col :span="4">分成方</el-col>
                  <el-col :span="20">
                    <el-select
                      v-model="item.dividendId"
                      placeholder="请选择分成方"
                    >
                      <el-option
                        v-for="(x, index) in recordsDividend"
                        :key="index"
                        :disabled="disabled(x, groupForm.groupDividendConfList)"
                        :label="x.name"
                        :value="x.id"
                      />
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="9" :xs="24">
                <el-row class="collapse_content">
                  <el-col :span="4">分成比例</el-col>
                  <el-col :span="20">
                    <el-form-item
                      :prop="
                        'groupDividendConfList.' + index + '.dividendRatio'
                      "
                      :rules="rules.dividendRatio"
                    >
                      <el-input
                        v-model.number="item.dividendRatio"
                        maxlength="3"
                        placeholder="请输入分成比例"
                      >
                        <template slot="append">%</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="6" :xs="24">
                <el-row class="collapse_content">
                  <el-col :span="24">
                    <el-col
                      v-if="
                        index === 0 && groupForm.groupDividendConfList.length
                      "
                      :span="8"
                      :xs="{ span: 8, offset: 6 }"
                    >
                      <el-button @click="reset(item)">重置 </el-button>
                    </el-col>
                    <el-col
                      v-if="index > 0"
                      :span="8"
                      :xs="{ span: 8, offset: 6 }"
                    >
                      <el-button
                        type="danger"
                        @click="
                          removeItem(item, groupForm.groupDividendConfList)
                        "
                        >删除</el-button
                      >
                    </el-col>
                    <el-col :span="8" :xs="8" class="m-mb-10">
                      <el-button type="primary" @click="addDividend"
                        >新增</el-button
                      >
                    </el-col>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item name="4">
            <template slot="title">
              <div class="collapse_label">
                <Icon
                  :style="{ color: '#29c19b' }"
                  class="label_icon"
                  icon="icon-jifen"
                />电费分成：
              </div>
            </template>
            <el-row :gutter="5">
              <el-col :span="12" :xs="24">
                <el-form-item label="电费成本" prop="costOfPowerFare">
                  <el-input
                    v-model="groupForm.costOfPowerFare"
                    placeholder="请输电费成本"
                  >
                    <template slot="append">元/度</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" :xs="24">
                <el-form-item label="电费分成" prop="electricityBillUserId">
                  <el-row>
                    <!-- <el-col :span="2">
                      <el-checkbox v-model="eShow" />
                    </el-col> -->
                    <el-col :span="22">
                      <el-select
                        clearable
                        v-model="groupForm.electricityBillUserId"
                        placeholder="请选电费分成方"
                      >
                        <el-option
                          v-for="x in recordsDividend"
                          :key="x.value"
                          :label="x.name"
                          :value="x.id"
                        />
                      </el-select>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>

        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item prop="chargeOnPlugIn">
              <template #label>
                <el-tooltip
                  effect="dark"
                  content="用户插上充电器后自动开始充电，且不收费"
                  placement="top-start"
                >
                  <label
                    >即插即充
                    <i
                      class="el-icon-question"
                      style="font-size: 17px; vertical-align: text-bottom"
                    ></i
                  ></label>
                </el-tooltip>
              </template>
              <el-switch
                v-model="groupForm.chargeOnPlugIn"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item prop="disableChargingByScanQrcode">
              <template #label>
                <el-tooltip
                  effect="dark"
                  content="开启此功能后，用户将无法通过扫码进行充电"
                  placement="top-start"
                >
                  <label
                    >禁用扫码充电
                    <i
                      class="el-icon-question"
                      style="font-size: 17px; vertical-align: text-bottom"
                    ></i
                  ></label>
                </el-tooltip>
              </template>
              <el-switch
                v-model="groupForm.disableChargingByScanQrcode"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="断电设置" prop="powerSettings">
              <el-select v-model="groupForm.powerSettings" placeholder="请选择">
                <el-option
                  v-for="item in outage"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24"> </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="12" :xs="24">
            <el-form-item label="最大功率" prop="maxPower">
              <el-input-number
                v-model.number="groupForm.maxPower"
                :min="100"
              ></el-input-number
              >&nbsp;&nbsp;瓦
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="限时充电" prop="chargeMaxTime">
              <el-input-number
                v-model.number="groupForm.chargeMaxTime"
                :min="1"
              ></el-input-number
              >&nbsp;&nbsp;小时
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12" :xs="24">
            <el-form-item label="收费方式">
              <el-button @click="chargeDialog = true">{{
                chargeValue
              }}</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-form-item label="包月方式">
              <el-radio-group v-model="radio" size="medium">
                <span @click.stop="monthDialog = true">
                  <el-radio-button :label="monthValue" />
                </span>
                <el-radio-button label="否" />
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer">
        <el-button @click="noDialog">取消</el-button>
        <el-button type="primary" @click="addPost">提交</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="chargeDialog"
      title="收费方式"
    >
      <el-table
        :data="AppTemplate"
        highlight-current-row
        @current-change="handleCurrentChange"
      >
        <el-table-column label="名称" prop="name" />
        <el-table-column label="电费价格">
          <template #default="scope"> {{ scope.row.powerFare }}元 </template>
        </el-table-column>
        <el-table-column label="起步价">
          <template #default="scope"> {{ scope.row.startingFare }}元 </template>
        </el-table-column>
        <el-table-column label="计费方式">
          <template #default="scope">
            {{ scope.row.chargeType === "1" ? "按时间" : "按度数" }}
          </template>
        </el-table-column>
        <el-table-column label="计费清单">
          <template #default="scope">
            <template v-if="scope.row.chargeType === '1'">
              <div
                v-for="(item, index) in scope.row.chargeTemplateInfoList"
                :key="index"
              >
                {{ item.startPower }}~{{ item.endPower }} {{ item.money }}元/{{
                  item.interval
                }}分钟
              </div>
            </template>
            <span v-else-if="scope.row.chargeType === '2'"
              >{{ scope.row.powerFare }}元/度</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="chargeDialog = false">取消</el-button>
        <el-button type="primary" @click="chargeDialog = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="monthDialog"
      title="包月方式"
    >
      <el-table
        :data="records"
        highlight-current-row
        @current-change="handleMonth"
      >
        <el-table-column label="名称" prop="name" />
        <el-table-column label="计费清单">
          <template #default="scope">
            <div
              v-for="(item, index) in JSON.parse(scope.row.monehlyInfo)"
              :key="index"
            >
              {{ item.startPower }}~{{ item.endPower }}瓦 {{ item.money }}元/{{
                item.freeDayNum
              }}天/{{ item.freeChargeNum }}次
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="monthDialog = false">取消</el-button>
        <el-button type="primary" @click="monthDialog = false">确定</el-button>
      </div>
    </el-dialog> -->
    <map-dialog :dialog.sync="mapDialog" />
  </div>
</template>

<script>
import addGroup from "@/maintain/api/device/device-group-manage/addGroup";
import maintainEditGroup from "@/maintain/api/device/device-group-manage/maintainEditGroup";
import maintainGetGroupDetailById from "@/maintain/api/device/device-group-manage/maintainGetGroupDetailById";
import maintenanceManGetAllDevidend from "@/maintain/api/user/dividend-manage/maintenanceManGetAllDevidend";

import MapDialog from "@/components/Dialog/mapDialog";
import createdMixin from "@/mixin/createMixin";
import dialogMixin from "@/mixin/dialogMixin";
import dividendMixin from "@/mixin/dividendMixin";
import listMixin from "@/mixin/listMixin";
import resDispose from "@/mixin/resDisposeMixin";
import templateMixin from "@/mixin/templateMixin/templateMixin";
import { dividendRatio, floatNumberMinZero } from "@/utils/check";
import { Message } from "element-ui";

export default {
  name: "addGroupDialog",
  mixins: [
    dialogMixin,
    createdMixin,
    resDispose,
    listMixin,
    dividendMixin,
    templateMixin,
  ],
  components: { MapDialog },
  props: {
    dialog: Boolean,
    group: Object,
    title: String,
  },
  data() {
    return {
      activeCollapse: "1",
      outage: [
        { value: "1", label: "充满自停" },
        { value: "2", label: "误拔断电" },
        { value: "3", label: "定时充电" },
      ],
      mapDialog: false,
      location: undefined,
      rules: {
        groupName: [
          { required: true, message: "请输入小区名", trigger: "change" },
        ],
        maxPower: [
          { required: true, message: "请输入最大功率" },
          { type: "number", message: "最大功率必须为数字值" },
        ],
        chargeMaxTime: [
          { required: true, message: "请输入限时充电" },
          { type: "number", message: "限时充电必须为数字值" },
        ],
        dividendRatio: [
          { type: "number", message: "必须为数字值" },
          { validator: dividendRatio },
        ],
        address: [{ required: true, message: "请输入具体位置" }],
        mobile: [{ required: true, message: "请输入手机号码" }],
        // mobile: checkPhone,
        powerSettings: [{ required: true, message: "请选择断电设置" }],
        // maxPower: [{ required: true, message: "请输入最大功率" }],
        // chargeMaxTime: [{ required: true, message: "请输最长充电时间" }],
        costOfPowerFare: [{ required: true, validator: floatNumberMinZero }],
      },
      groupForm: {
        groupName: undefined,
        address: undefined,
        maxPower: 1000,
        chargeMaxTime: 10,
        powerSettings: "1",
        costOfPowerFare: 0,
        chargeOnPlugIn: 0,
        disableChargingByScanQrcode: 0,
        groupDividendConfList: [
          {
            dividendId: undefined,
            dividendRatio: undefined,
          },
        ],
      },
      // eShow: false,
      isPeekCharge: 0,
      radio: "否",
      params: {
        // chargeTemplateId: undefined,
        // monthlyTemplateId: undefined,
        chargeTemplateInfoList: [
          {
            interval: 60,
            money: undefined,
            startPower: 0,
            endPower: 800,
          },
        ],
        chargeType: "1",
        returnTheBalance: "1",
        // name: undefined,
        powerFare: undefined,
        powerServiceFare: undefined,
        startingFare: 0,
        serviceChargeByTime: 0,
        serviceChargeTime: 60,
        serviceChargeTimeMoney: 0,
        informationOfChargeByPowerList: [
          {
            peak: "1",
            startTime: 0,
            endTime: 24,
            powerFare: undefined,
            powerServiceFare: undefined,
          },
        ],
      },
      params2: {
        name: undefined,
        monthlyInfoList: [
          {
            startPower: 0,
            endPower: undefined,
            freeChargeNum: undefined,
            freeDayNum: undefined,
            money: undefined,
          },
        ],
      },
      chargeValue: "选择收费方式",
      monthValue: "选择包月方式",
      chargeDialog: false,
      monthDialog: false,
      // AppTemplate: [
      //   {
      //     chargeTemplateInfoList: [
      //       {
      //         endPower: 0,
      //         interval: 0,
      //         money: 0,
      //         startPower: 0,
      //         tempId: 0,
      //       },
      //     ],
      //     chargeType: "",
      //     id: 0,
      //     name: "",
      //     powerFare: 0,
      //     returnTheBalance: "",
      //     startingFare: 0,
      //   },
      // ],
      recordsDividend: [],
      // records: [
      //   {
      //     monehlyInfo: undefined,
      //     name: undefined,
      //   },
      // ],
      chargeRuleByDegType: "1",
      isStartingPrice: 0,
    };
  },
  mounted() {
    // this.location = {
    //   detail: {
    //     addressComponents: {
    //       province: "四川省",
    //       district: "成华区",
    //       city: "成都市",
    //     },
    //   },
    // };
    // this.groupForm.address = "成都市成华区人民政府";
    // this.groupForm.lat = 30.65984;
    // this.groupForm.lng = 104.10194;
    // this.groupForm.province = "四川省";
    // this.groupForm.district = "成华区";
    // this.groupForm.city = "成都市";

    this.refresh.$on("mapDialog", (location) => {
      this.location = location;
      console.log(location, location.detail);
      this.groupForm.address = location.detail.address;
      this.groupForm.lat = location.detail.location.lat;
      this.groupForm.lng = location.detail.location.lng;
      this.groupForm.province = location.detail.addressComponents.province;
      this.groupForm.district = location.detail.addressComponents.district;
      this.groupForm.city = location.detail.addressComponents.city;
      this.mapDialog = false;
    });
  },
  computed: {
    locationText() {
      if (!this.location) return "";
      return `${this.location.detail.addressComponents.province} / ${this.location.detail.addressComponents.city} / ${this.location.detail.addressComponents.district}`;
    },
    startTimeMinValue() {
      return (index) => {
        const pre = this.params.informationOfChargeByPowerList[index - 1];
        return pre ? pre.startTime + 1 : 0;
      };
    },
    startTimeMaxValue() {
      return (item) => item.endTime - 1;
    },
    endTimeMinValue() {
      return (item) => item.startTime + 1;
    },
    endTimeMaxValue() {
      return (index) => {
        const next = this.params.informationOfChargeByPowerList[index + 1];
        return next ? next.endTime - 1 : 24;
      };
    },
  },
  watch: {
    // radio(newV) {
    //   if (newV !== "否") {
    //     this.monthDialog = true;
    //   } else {
    //     this.monthValue = "选择包月方式";
    //     this.params.monthlyTemplateId = undefined;
    //   }
    // },
    chargeRuleByDegType() {
      console.log(9999, this.params);
    },
    // eShow(newV) {
    //   if (newV === false) {
    //     this.resetElectricityId();
    //   }
    // },
    group() {
      // this.groupForm.groupName = this.group.groupName;
      // this.groupForm.id = this.group.id;
      // this.groupForm.chargeTemplateId = undefined;
      // this.groupForm.monthlyTemplateId = undefined;
      // if (
      //   this.group.dividendConfigList !== undefined &&
      //   this.group.dividendConfigList.length > 0
      // ) {
      //   this.groupForm.dividendConfigList = this.group.dividendConfigList;
      // }

      if (this.group.id) {
        maintainGetGroupDetailById({
          id: this.group.id,
        }).then((res) => {
          this.groupForm.groupDividendConfList =
            res.data.groupDividendConfList.length > 0
              ? res.data.groupDividendConfList
              : [
                  {
                    dividendId: undefined,
                    dividendRatio: undefined,
                  },
                ];

          this.groupForm = res.data;
          if (this.groupForm.electricityBillUserId) {
            // this.eShow = true;
          } else {
            this.resetElectricityId();
          }
          Object.keys(this.params).forEach((key) => {
            if (this.groupForm[key]) this.params[key] = this.groupForm[key];
          });
          this.location = {
            detail: {
              address: this.groupForm.address,
              addressComponents: {
                province: this.groupForm.province,
                district: this.groupForm.district,
                city: this.groupForm.city,
              },
              location: {
                lat: this.groupForm.lat,
                lng: this.groupForm.lng,
              },
            },
            type: "GEO_INFO",
          };

          if (
            this.params.serviceChargeByTime != 0 &&
            this.params.serviceChargeByTime != 1
          ) {
            this.params.serviceChargeByTime = 0;
          }

          if (
            this.groupForm.informationOfChargeByPowerList &&
            this.groupForm.informationOfChargeByPowerList.length
          ) {
            // 大于1条则表示开启峰谷收费
            if (this.params.informationOfChargeByPowerList.length > 1) {
              this.isPeekCharge = 1;
            }
            this.params.informationOfChargeByPowerList =
              this.groupForm.informationOfChargeByPowerList.map((item) => ({
                ...item,
                peak: item.peak + "",
              }));
          } else if (
            !this.params.informationOfChargeByPowerList ||
            !this.params.informationOfChargeByPowerList.length
          ) {
            // 关闭峰谷收费
            this.isPeekCharge = 0;
            this.params.informationOfChargeByPowerList = [
              {
                peak: "1",
                startTime: 0,
                endTime: 24,
                powerFare: this.params.powerFare || undefined,
                powerServiceFare: this.params.powerServiceFare || undefined,
              },
            ];
          }
          // 是否开启起步价
          this.isStartingPrice = this.params.startingFare > 0 ? 1 : 0;

          // if (this.params.chargeType == "2") {
          //   this.chargeRuleByDegType = "1";
          //   if (!(this.groupForm.informationOfChargeByPowerList || []).length) {
          //   }
          // }
          // this.chargeRuleByDegType = String(
          //   +!!(this.groupForm.informationOfChargeByPowerList || []).length
          // );
          // 按时间中的价格详细列表(params.chargeTemplateInfoList)
          if (
            this.groupForm.deviceGroupChargeList &&
            this.groupForm.deviceGroupChargeList.length
          ) {
            this.params.chargeTemplateInfoList =
              this.groupForm.deviceGroupChargeList;
            if (
              this.params.chargeTemplateInfoList.length == 1 &&
              this.params.chargeTemplateInfoList[0].startPower == 0 &&
              this.params.chargeTemplateInfoList[0].endPower == 800
            ) {
              this.params.chargeType = "1";
            } else {
              this.params.chargeType = "3";
            }
          } else {
            this.params.chargeTemplateInfoList = [
              {
                interval: 60,
                money: undefined,
                startPower: 0,
                endPower: 800,
              },
            ];
          }
          // 包月方式(params2.monthlyInfoList)
          if (
            this.groupForm.monthlyInfoList &&
            this.groupForm.monthlyInfoList.length
          ) {
            this.params2.monthlyInfoList = this.groupForm.monthlyInfoList;
            this.params2.monthlyInfoList.sort(
              (a, b) => a.endPower - b.endPower
            );
          }
          // 设置分成方(groupForm.groupDividendConfList)
          if (
            !this.groupForm.groupDividendConfList ||
            !this.groupForm.groupDividendConfList.length
          ) {
            this.addDividend();
          }
        });
      }
    },
  },
  methods: {
    changeChargeType() {
      if (this.params.chargeType != "2") {
        this.params.chargeTemplateInfoList = [
          {
            interval: 60,
            money: undefined,
            startPower: 0,
            endPower: 800,
          },
        ];
      }
    },
    handleFareInput(index, prop) {
      const regex = /^\d*\.?\d{0,4}$/; // 正则表达式：允许最多4位小数
      if (
        !regex.test(this.params.informationOfChargeByPowerList[index][prop])
      ) {
        this.$set(this.params.informationOfChargeByPowerList, index, {
          ...this.params.informationOfChargeByPowerList[index],
          [prop]: this.params.informationOfChargeByPowerList[index][prop].slice(
            0,
            -1
          ), // 移除最后一个字符
        });
        // this.params[prop] = this.params.informationOfChargeByPowerList[index][prop].slice(
        //   0,
        //   -1
        // ); // 移除最后一个字符
      }
    },
    // 开始时间步进器值改变时触发
    handleStartTimeNumberBoxChange(e, index) {
      if (this.params.informationOfChargeByPowerList[index - 1]) {
        this.params.informationOfChargeByPowerList[index - 1].endTime = e;
      }
    },
    // 结束时间步进器值改变时触发
    handleEndTimeNumberBoxChange(e, index) {
      if (this.params.informationOfChargeByPowerList[index + 1]) {
        this.params.informationOfChargeByPowerList[index + 1].startTime = e;
      }
    },
    // 点击新增收费规则按钮时触发
    handleAddChargeRule() {
      const lastRule =
        this.params.informationOfChargeByPowerList[
          this.params.informationOfChargeByPowerList.length - 1
        ];
      if (lastRule.powerFare === undefined || +lastRule.powerFare < 0) {
        return Message({
          message: "请先正确设置上一时段的电费~",
          type: "error",
          duration: 3 * 1000,
        });
      }
      if (
        this.params.serviceChargeByTime == 0 &&
        (lastRule.powerServiceFare === undefined ||
          +lastRule.powerServiceFare < 0)
      ) {
        return Message({
          message: "请先正确设置上一时段的服务费~",
          type: "error",
          duration: 3 * 1000,
        });
      }
      this.params.informationOfChargeByPowerList.push({
        peak: "1",
        startTime: lastRule.endTime,
        endTime: 24,
        powerFare: undefined,
        powerServiceFare: undefined,
      });
    },
    // 点击删除收费规则按钮时触发
    handleRemoveChargeRule() {
      this.params.informationOfChargeByPowerList.splice(
        this.params.informationOfChargeByPowerList.length - 1,
        1
      );
    },
    resetElectricityId() {
      this.groupForm.electricityBillUserId = undefined;
    },
    handleIsPeekChargeSwitchChange() {
      this.params.informationOfChargeByPowerList = [
        {
          peak: "1",
          startTime: 0,
          endTime: 24,
          powerFare: undefined,
          powerServiceFare: undefined,
        },
      ];
    },
    handleIsStartingPriceSwitchChange() {
      this.params.startingFare = 0;
    },
    fetchData() {
      // agentGetTheOwnChargeTemplate().then((res) => {
      //   this.AppTemplate = res.data;
      // });
      // agentGetTheOwnAllMonthlyTemplate().then((res) => {
      //   this.records = res.data;
      // });
      maintenanceManGetAllDevidend().then((res) => {
        this.recordsDividend = res.data;
      });
    },
    addDividend() {
      this.groupForm.groupDividendConfList.push({
        dividendRatio: undefined,
        dividendId: undefined,
      });
    },
    reset() {
      this.groupForm.groupDividendConfList[0].dividendId = undefined;
      this.groupForm.groupDividendConfList[0].dividendRatio = undefined;
    },
    async addPost() {
      console.log(this.group, this.params, 777);
      if (this.group && this.group.id) this.groupForm.groupId = this.group.id;

      if (this.location === undefined) {
        Message({
          message: "请先定位获取经纬度~",
          type: "error",
          duration: 3 * 1000,
        });
        return false;
      }
      // 按度数收费
      if (this.params.chargeType === "2") {
        // 固定电价
        if (this.chargeRuleByDegType == "0") {
          if (
            this.params.powerFare === undefined ||
            +this.params.powerFare < 0
          ) {
            Message({
              message: "按度数收费需要正确设置电费价格~",
              type: "error",
              duration: 3 * 1000,
            });
            return false;
          }
          if (
            this.params.powerServiceFare === undefined ||
            +this.params.powerServiceFare < 0
          ) {
            Message({
              message: "按度数收费需要正确设置服务费用~",
              type: "error",
              duration: 3 * 1000,
            });
            return false;
          }

          this.params.informationOfChargeByPowerList = [];
        } else {
          if (this.params.serviceChargeByTime == 1) {
            if (
              this.params.serviceChargeTime == undefined ||
              this.params.serviceChargeTime < 1
            ) {
              Message({
                message: "按时间收服务费需要正确设置分钟~",
                type: "error",
                duration: 3 * 1000,
              });
              return false;
            }
            if (
              this.params.serviceChargeTimeMoney == undefined ||
              this.params.serviceChargeTimeMoney < 0
            ) {
              Message({
                message: "按时间收服务费需要正确设置价格~",
                type: "error",
                duration: 3 * 1000,
              });
              return false;
            }
          }

          // 分时计费
          const powerFareNoSet =
            this.params.informationOfChargeByPowerList.some(
              (c) =>
                c.powerFare === undefined ||
                c.powerFare === "" ||
                +c.powerFare < 0
            );
          if (powerFareNoSet) {
            Message({
              message: "按度数收费需要正确设置电费价格~",
              type: "error",
              duration: 3 * 1000,
            });
            return false;
          }

          if (this.params.serviceChargeByTime == 0) {
            const powerServiceFareNoSet =
              this.params.informationOfChargeByPowerList.some(
                (c) =>
                  c.powerServiceFare === undefined ||
                  c.powerServiceFare === "" ||
                  +c.powerServiceFare < 0
              );
            if (powerServiceFareNoSet) {
              Message({
                message: "按度数收费需要正确设置服务费用~",
                type: "error",
                duration: 3 * 1000,
              });
              return false;
            }
          }

          // 是否分配完24小时
          const max = Math.max(
            ...this.params.informationOfChargeByPowerList.map((i) => i.endTime)
          );
          if (max < 24) {
            Message({
              message: "分时计费需要分配完24小时~",
              type: "error",
              duration: 3 * 1000,
            });
            return false;
          }

          this.params.powerFare = 0;
          this.params.powerServiceFare = 0;
        }
      } else if (
        this.params.chargeType === "1" ||
        this.params.chargeType === "3"
      ) {
        // 按时间收费
        const valid = await this.$refs.params.validate().catch(() => false);
        console.log(valid, 9);
        if (!valid) {
          return Message({
            message: "收费需要正确设置价格详细~",
            type: "error",
            duration: 3 * 1000,
          });
        }
        this.params.serviceChargeByTime = 2;
        // const chargeTemplate = this.params.chargeTemplateInfoList[0];
        // const flag = Object.keys(chargeTemplate).some(
        //   (key) =>
        //     key != "startPower" &&
        //     (chargeTemplate[key] === undefined || chargeTemplate[key] < 0)
        // );
        // if (flag) {
        //   Message({
        //     message: "按时间收费需要正确设置价格详细~",
        //     type: "error",
        //     duration: 3 * 1000,
        //   });
        //   return false;
        // }
      }
      // if (this.params2.monthlyInfoList && this.params2.monthlyInfoList.length) {
      //   for (const item of this.params2.monthlyInfoList) {
      //     if (Object.keys(item).some((key) => !item[key] || item[key] <= 0)) {
      //       Message({
      //         message: "请将包月方式填写完整~",
      //         type: "error",
      //         duration: 3 * 1000,
      //       });
      //       return false;
      //     }
      //   }
      // }

      // 按时间收服务费，将分时计费里面的服务费设置为0
      if (this.params.serviceChargeByTime == 1) {
        this.params.informationOfChargeByPowerList =
          this.params.informationOfChargeByPowerList.map((item) => ({
            ...item,
            powerServiceFare: 0,
          }));
      }

      this.$refs["Dto"].validate((valid) => {
        if (valid) {
          let Dto = { ...this.groupForm };
          if (
            Dto.groupDividendConfList.length === 1 &&
            (!Dto.groupDividendConfList[0].dividendRatio ||
              !Dto.groupDividendConfList[0].dividendId)
          ) {
            delete Dto.groupDividendConfList;
          }
          let validP2 = true;
          if (
            this.params2.monthlyInfoList.length === 1 &&
            (!this.params2.monthlyInfoList[0].money ||
              !this.params2.monthlyInfoList[0].freeChargeNum ||
              !this.params2.monthlyInfoList[0].endPower)
          ) {
            delete this.params2.monthlyInfoList;
          } else {
            this.$refs["params2"].validate((valid2) => {
              validP2 = valid2;
              if (valid2) {
                // 升序排序，并设置每一个的startPower为上一个的endPower
                this.params2.monthlyInfoList =
                  this.params2.monthlyInfoList.sort(
                    (a, b) => a.endPower - b.endPower
                  );
                this.params2.monthlyInfoList.map((m, i) => {
                  if (this.params2.monthlyInfoList[i - 1])
                    m.startPower = this.params2.monthlyInfoList[i - 1].endPower;
                });
              }
            });
          }
          if (!validP2) {
            return Message({
              message: "请先将包月方式填写完整~",
              type: "error",
              duration: 3000,
            });
          }

          if (!Dto.electricityBillUserId) {
            Dto.electricityBillUserId = 0;
          }
          this.loadStart();
          console.log(this.params, Dto);
          const chargeTemplate = { ...this.params };
          if (chargeTemplate.chargeType === "3") {
            chargeTemplate.chargeType = "1";
          }
          // 修改
          if (this.group.id) {
            maintainEditGroup({
              deviceGroup: Dto,
              chargeTemplate,
              monthlyInfoList: this.params2.monthlyInfoList,
            })
              .then((res) => {
                if (res.code === 1) {
                  this.$emit("fetchGroup");
                  this.$emit("update:dialog", false);
                  Message({
                    message: res.msg,
                    type: "success",
                  });
                } else {
                  Message({
                    message: res.msg,
                    type: "error",
                    duration: 3000,
                  });
                }
                // this.resNoDialog({ res });
                // getGroupList().then((res) => {
                //   this.$parent.GroupList = res.data;
                // });
              })
              .finally(() => {
                this.loadDialog.close();
              });
          } else {
            // 新增
            addGroup({
              deviceGroup: Dto,
              chargeTemplate,
              monthlyInfoList: this.params2.monthlyInfoList,
            })
              .then((res) => {
                if (res.code === 1) {
                  this.$emit("fetchGroup");
                  this.$emit("update:dialog", false);
                  Message({
                    message: res.msg,
                    type: "success",
                  });
                } else {
                  Message({
                    message: res.msg,
                    type: "error",
                    duration: 3000,
                  });
                }
                // this.resNoDialog({ res });
                // console.log(this)
                // getGroupList().then((res) => {
                //   this.$parent.GroupList = res.data;
                // });
              })
              .finally(() => {
                this.loadDialog.close();
              });
          }
        }
      });
    },
    // handleCurrentChange(val) {
    //   this.params.chargeTemplateId = val.id;
    //   this.chargeValue = "当前已选" + val.name;
    // },
    // handleMonth(val) {
    //   this.params.monthlyTemplateId = val.id;
    //   this.monthValue = "当前已选" + val.name;
    //   this.radio = this.monthValue;
    // },
  },
};
</script>
<style lang="scss" scoped>
@import "src/styles/my";
@include mobile {
  .collapse_content {
    flex-wrap: wrap;
    .collapse_content_wrapper {
      flex-wrap: wrap;
      margin-top: 0.625rem;
      margin-bottom: 0 !important;

      .wrapper_detail {
        margin-bottom: 0.3125rem;
      }
    }
  }
}

.collapse_label {
  font-size: 14px;
  color: #606266;
  font-weight: bold;
  display: flex;
  align-items: center;
  .label_icon {
    margin-right: 0.5rem;
    font-size: 1.25rem;
    font-weight: 100;
  }
  .required_icon {
    font-size: 1.35rem;
    font-weight: 100;
  }
}

.col_line {
  height: 2.5rem;
  line-height: 2.5rem;
  text-align: center;
}

.collapse_content {
  display: flex;
  align-items: center;
  margin: 0.625rem 0;

  /deep/ .el-form-item {
    margin-bottom: 0 !important;
  }

  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  .collapse_content_wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .content_title {
    margin-right: 10px;
  }
}

/deep/ .el-divider--horizontal {
  margin: 26px 0 20px;
}

.content_charge_rule {
  padding-bottom: 14px;
  border-bottom: 1px solid #eee;
}
</style>
